if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
        constructor() {
            super();
            this._onPlayClick = this._onPlayClick.bind(this);
            this._onVideoClick = this._onVideoClick.bind(this);
            this._onPopupCloseClick = this._onPopupCloseClick.bind(this);
        }

        connectedCallback() {
            this.video = this.querySelector('.video-el');
            this.videoBtn = this.querySelector('.control');
            this.popup = this.querySelector('.popup-video');
            if (this.videoBtn) {
                this.videoBtn.addEventListener('click', this._onPlayClick);
            }
            if (this.popup) {
                this._attachPopupEvents();
            }
        }

        disconnectedCallback() {
            if (this.videoBtn) {
                this.videoBtn.removeEventListener('click', this._onPlayClick);
            }
            if (this.video) {
                this.video.removeEventListener('click', this._onVideoClick);
            }
            if (this.popup) {
                this._detachPopupEvents();
            }
        }

        _onPlayClick() {
            // If popup exists, show popup and play video inside it
            if (this.popup) {
                this.popup.style.display = 'block';
                setTimeout(() => {
                    this.popup.style.opacity = 1;
                }, 10);
                const popupVideo = this.popup.querySelector('video.video-el');
                if (popupVideo) {
                    popupVideo.play();
                }
            } else {
                this._playVideo();
                if (this.videoBtn.getAttribute('listener') !== 'true') {
                    this.video.addEventListener('click', this._onVideoClick);
                    this.videoBtn.setAttribute('listener', 'true');
                }
            }
        }

        _onVideoClick() {
            this._pauseVideo();
            this.videoBtn.classList.remove('hidden');
        }

        _playVideo() {
            if (this.video) {
                this.video.play();
                this.videoBtn.classList.add('hidden');
            }
        }

        _pauseVideo() {
            if (this.video) {
                this.video.pause();
                this.videoBtn.classList.remove('hidden');
            }
        }

        _attachPopupEvents() {
            this.popupCloseBtn = this.popup.querySelector('span');
            if (this.popupCloseBtn) {
                this.popupCloseBtn.addEventListener('click', this._onPopupCloseClick);
            }
        }

        _detachPopupEvents() {
            if (this.popupCloseBtn) {
                this.popupCloseBtn.removeEventListener('click', this._onPopupCloseClick);
            }
        }

        _onPopupCloseClick() {
            if (this.popup) {
                this.popup.style.opacity = 0;
                setTimeout(() => {
                    this.popup.style.display = 'none';
                }, 400); // match fadeOut duration
                const popupVideo = this.popup.querySelector('video.video-el');
                if (popupVideo) {
                    popupVideo.pause();
                }
            }
        }
    }

    customElements.define('video-player', VideoPlayer);
}
